<template>
  <Section
    @back="$emit('back')"
    title="クリエイティブ"
    margin
    tip-message="クリエイティブ設定に戻る"
  >
    <v-subheader>クリエイティブ種別</v-subheader>
    <v-layout pl-4>
      <v-flex>
        <AppCreativeType :value="form.campaign.creativeType" />
      </v-flex>
    </v-layout>
    <v-subheader>設定方法</v-subheader>
    <v-layout pl-4>
      <v-flex>{{ attachTargetText }}</v-flex>
    </v-layout>
    <v-subheader>クリエイティブ配信設定</v-subheader>
    <v-layout pl-4>
      <ModeCampaign v-if="attachTargetIsCampaign" :form="form" />
      <ModeDeliveryGroup v-else :form="form" />
    </v-layout>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection.vue'
import { CreativeAttachTargets } from '@/models/CampaignOperation'
import ModeCampaign from './CampaignModalPageConfirmCreativeModeCampaign'
import ModeDeliveryGroup from './CampaignModalPageConfirmCreativeModeDeliveryGroup'

export default {
  name: 'CampaignModalPageConfirmCreative',
  components: {
    Section,
    ModeCampaign,
    ModeDeliveryGroup,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    attachTarget() {
      return this.form.campaign.creativeAttachTarget
    },
    attachTargetIsCampaign() {
      return this.attachTarget === CreativeAttachTargets.CAMPAIGN
    },
    attachTargetText() {
      if (this.attachTargetIsCampaign) {
        return 'キャンペーン全体'
      } else {
        return '配置地点グループごとに設定する'
      }
    },
  },
}
</script>

<style></style>
